// Generated by api/build-index.js; do not edit. Run: npm run api-index -w @jscadui/agent-loop
export const OPTION_TABLES = {
  "@jscad/modeling": {
    prefix: "",
    options: {
      "primitives.arc": ["center","endAngle","makeTangent","radius","segments","startAngle"],
      "primitives.circle": ["center","endAngle","radius","segments","startAngle"],
      "primitives.cube": ["center","size"],
      "primitives.cuboid": ["center","size"],
      "primitives.cylinder": ["center","height","radius","segments"],
      "primitives.cylinderElliptic": ["center","endAngle","endRadius","height","segments","startAngle","startRadius"],
      "primitives.ellipse": ["center","endAngle","radius","segments","startAngle"],
      "primitives.ellipsoid": ["axes","center","radius","segments"],
      "primitives.geodesicSphere": ["frequency","radius"],
      "primitives.polygon": ["orientation","paths","points"],
      "primitives.polyhedron": ["colors","faces","orientation","points"],
      "primitives.rectangle": ["center","size"],
      "primitives.roundedCuboid": ["center","roundRadius","segments","size"],
      "primitives.roundedCylinder": ["center","height","radius","roundRadius","segments"],
      "primitives.roundedRectangle": ["center","roundRadius","segments","size"],
      "primitives.sphere": ["axes","center","radius","segments"],
      "primitives.square": ["center","size"],
      "primitives.star": ["center","density","innerRadius","outerRadius","startAngle","vertices"],
      "primitives.torus": ["innerRadius","innerRotation","innerSegments","outerRadius","outerRotation","outerSegments","startAngle"],
      "primitives.triangle": ["type","values"],
      "transforms.align": ["grouped","modes","relativeTo"],
      "transforms.center": ["axes","relativeTo"],
      "transforms.mirror": ["normal","origin"],
      "extrusions.extrudeFromSlices": ["callback","capEnd","capStart","close","numberOfSlices","repair"],
      "extrusions.extrudeLinear": ["height","repair","twistAngle","twistSteps"],
      "extrusions.extrudeRectangular": ["corners","delta","height","repair","segments","size","twistAngle","twistSteps"],
      "extrusions.extrudeRotate": ["angle","overflow","segments","startAngle"],
      "extrusions.extrudeHelical": ["angle","endOffset","height","pitch","segmentsPerRotation","startAngle"],
      "extrusions.project": ["axis","origin"],
      "expansions.expand": ["corners","delta","segments"],
      "expansions.offset": ["closed","corners","delta","segments"],
      "modifiers.generalize": ["simplify","snap","triangulate"],
      "curves.bezier.arcLengthToT": ["distance","segments"],
      "text.vectorChar": ["extrudeOffset","font","height","input","xOffset","yOffset"],
      "text.vectorText": ["align","extrudeOffset","font","height","input","letterSpacing","lineSpacing","xOffset","yOffset"],
    },
    methods: {},
    optionsAt: {},
    methodOptionsAt: {},
    types: {
      "primitives.arc": {"center":"array","endAngle":"number","radius":"number","segments":"number","startAngle":"number"},
      "primitives.circle": {"center":"array","endAngle":"number","radius":"number","segments":"number","startAngle":"number"},
      "primitives.cube": {"center":"array","size":"number"},
      "primitives.cuboid": {"center":"array","size":"array"},
      "primitives.cylinder": {"center":"array","height":"number","radius":"number","segments":"number"},
      "primitives.cylinderElliptic": {"center":"array","endAngle":"number","endRadius":"array","height":"number","segments":"number","startAngle":"number","startRadius":"array"},
      "primitives.ellipse": {"center":"array","endAngle":"number","radius":"array","segments":"number","startAngle":"number"},
      "primitives.ellipsoid": {"axes":"array","center":"array","radius":"array","segments":"number"},
      "primitives.geodesicSphere": {"frequency":"number","radius":"number"},
      "primitives.polygon": {"paths":"array","points":"array"},
      "primitives.polyhedron": {"colors":"array","faces":"array","points":"array"},
      "primitives.rectangle": {"center":"array","size":"array"},
      "primitives.roundedCuboid": {"center":"array","roundRadius":"number","segments":"number","size":"array"},
      "primitives.roundedCylinder": {"center":"array","height":"number","radius":"number","roundRadius":"number","segments":"number"},
      "primitives.roundedRectangle": {"center":"array","roundRadius":"number","segments":"number","size":"array"},
      "primitives.sphere": {"axes":"array","center":"array","radius":"number","segments":"number"},
      "primitives.square": {"center":"array","size":"number"},
      "primitives.star": {"center":"array","density":"number","innerRadius":"number","outerRadius":"number","startAngle":"number","vertices":"number"},
      "primitives.torus": {"innerRadius":"number","innerRotation":"number","innerSegments":"number","outerRadius":"number","outerRotation":"number","outerSegments":"number","startAngle":"number"},
      "primitives.triangle": {"values":"array"},
      "transforms.align": {"modes":"array","relativeTo":"array"},
      "transforms.center": {"axes":"array","relativeTo":"array"},
      "transforms.mirror": {"normal":"array","origin":"array"},
      "extrusions.extrudeFromSlices": {"numberOfSlices":"number"},
      "extrusions.extrudeLinear": {"height":"number","twistAngle":"number","twistSteps":"number"},
      "extrusions.extrudeRectangular": {"delta":"number","height":"number","segments":"number","size":"number","twistAngle":"number","twistSteps":"number"},
      "extrusions.extrudeRotate": {"angle":"number","segments":"number","startAngle":"number"},
      "extrusions.extrudeHelical": {"angle":"number","endOffset":"number","height":"number","pitch":"number","segmentsPerRotation":"number","startAngle":"number"},
      "extrusions.project": {"axis":"array","origin":"array"},
      "expansions.expand": {"delta":"number","segments":"number"},
      "expansions.offset": {"delta":"number","segments":"number"},
      "curves.bezier.arcLengthToT": {"distance":"number","segments":"number"},
      "text.vectorChar": {"extrudeOffset":"number","height":"number","xOffset":"number","yOffset":"number"},
      "text.vectorText": {"extrudeOffset":"number","height":"number","letterSpacing":"number","lineSpacing":"number","xOffset":"number","yOffset":"number"},
    },
    methodTypes: {},
    angles: ["transforms.rotate","transforms.rotateX","transforms.rotateY","transforms.rotateZ"],
    methodAngles: {},
  },
  "@jbroll/jscad-fluent": {
    prefix: "jf.",
    options: {
      "arc": ["center","endAngle","makeTangent","radius","segments","startAngle"],
      "path": ["closed"],
      "rectangle": ["center","size"],
      "roundedRectangle": ["center","roundRadius","segments","size"],
      "circle": ["center","endAngle","radius","segments","startAngle"],
      "ellipse": ["center","endAngle","radius","segments","startAngle"],
      "square": ["center","size"],
      "star": ["center","density","innerRadius","outerRadius","startAngle","vertices"],
      "triangle": ["type","values"],
      "cube": ["center","size"],
      "cuboid": ["center","size"],
      "sphere": ["axes","center","radius","segments"],
      "cylinder": ["angle","center","height","inner","outer","radius","segments","wall"],
      "cylinderElliptic": ["center","endAngle","endRadius","height","segments","startAngle","startRadius"],
      "torus": ["innerRadius","innerRotation","innerSegments","outerRadius","outerRotation","outerSegments","startAngle"],
      "ellipsoid": ["axes","center","radius","segments"],
      "geodesicSphere": ["frequency","radius"],
      "roundedCuboid": ["center","roundRadius","segments","size"],
      "roundedCylinder": ["center","height","radius","roundRadius","segments"],
      "polyhedron": ["faces","points"],
      "extrudeFromSlices": ["callback","capEnd","capStart","close","numberOfSlices","repair"],
      "align": ["grouped","modes","relativeTo"],
      "vectorText": ["align","extrudeOffset","font","height","input","letterSpacing","lineSpacing","xOffset","yOffset"],
      "vectorChar": ["extrudeOffset","font","height","input","xOffset","yOffset"],
      "subtract": ["carry"],
    },
    methods: {
      "FluentGeom2": {
        "mirror": ["normal","origin"],
        "center": ["axes","relativeTo"],
        "align": ["grouped","modes","relativeTo"],
        "expand": ["corners","delta","segments"],
        "offset": ["closed","corners","delta","segments"],
        "extrudeLinear": ["height","repair","twistAngle","twistSteps"],
        "extrudeRotate": ["angle","overflow","segments","startAngle"],
        "extrudeHelical": ["angle","endOffset","height","pitch","segmentsPerRotation","startAngle"],
        "extrudeRectangular": ["corners","delta","height","repair","segments","size","twistAngle","twistSteps"],
        "extrudeFromSlices": ["callback","capEnd","capStart","close","numberOfSlices","repair"],
        "generalize": ["simplify","snap","triangulate"],
        "attachTo": ["flip","overlap","spin"],
        "alignTo": ["inside","inset"],
        "subtract": ["carry"],
      },
      "FluentGeom3": {
        "mirror": ["normal","origin"],
        "center": ["axes","relativeTo"],
        "align": ["grouped","modes","relativeTo"],
        "expand": ["corners","delta","segments"],
        "project": ["axis","origin"],
        "generalize": ["simplify","snap","triangulate"],
        "attachTo": ["flip","overlap","spin"],
        "alignTo": ["inside","inset"],
        "subtract": ["carry"],
      },
      "FluentPath2": {
        "mirror": ["normal","origin"],
        "center": ["axes","relativeTo"],
        "align": ["grouped","modes","relativeTo"],
        "expand": ["corners","delta","segments"],
        "extrudeRectangular": ["corners","delta","height","repair","segments","size","twistAngle","twistSteps"],
        "offset": ["closed","corners","delta","segments"],
        "appendArc": ["clockwise","endpoint","large","radius","segments","xaxisrotation"],
        "appendBezier": ["controlPoints","segments"],
        "generalize": ["simplify","snap","triangulate"],
      },
      "FluentGeometryArray": {
        "mirror": ["normal","origin"],
        "center": ["axes","relativeTo"],
        "align": ["grouped","modes","relativeTo"],
      },
      "FluentGeom2Array": {
        "extrudeLinear": ["height","repair","twistAngle","twistSteps"],
        "extrudeRotate": ["angle","overflow","segments","startAngle"],
        "extrudeHelical": ["angle","endOffset","height","pitch","segmentsPerRotation","startAngle"],
        "extrudeRectangular": ["corners","delta","height","repair","segments","size","twistAngle","twistSteps"],
      },
      "FluentPath2Array": {
        "expand": ["corners","delta","segments"],
        "extrudeRectangular": ["corners","delta","height","repair","segments","size","twistAngle","twistSteps"],
      },
    },
    optionsAt: {
      "subtract": "last",
    },
    methodOptionsAt: {
      "FluentGeom2": {
        "attachTo": 3,
        "alignTo": 2,
        "subtract": "last",
      },
      "FluentGeom3": {
        "attachTo": 3,
        "alignTo": 2,
        "subtract": "last",
      },
    },
    types: {
      "arc": {"center":"array","endAngle":"number","radius":"number","segments":"number","startAngle":"number"},
      "rectangle": {"center":"array","size":"array"},
      "roundedRectangle": {"center":"array","roundRadius":"number","segments":"number","size":"array"},
      "circle": {"center":"array","endAngle":"number","radius":"number","segments":"number","startAngle":"number"},
      "ellipse": {"center":"array","endAngle":"number","radius":"array","segments":"number","startAngle":"number"},
      "square": {"center":"array","size":"number"},
      "star": {"center":"array","density":"number","innerRadius":"number","outerRadius":"number","startAngle":"number","vertices":"number"},
      "triangle": {"values":"array"},
      "cube": {"center":"array","size":"number"},
      "cuboid": {"center":"array","size":"array"},
      "sphere": {"axes":"array","center":"array","radius":"number","segments":"number"},
      "cylinder": {"angle":"array","center":"array","height":"number","segments":"number"},
      "cylinderElliptic": {"center":"array","endAngle":"number","endRadius":"array","height":"number","segments":"number","startAngle":"number","startRadius":"array"},
      "torus": {"innerRadius":"number","innerRotation":"number","innerSegments":"number","outerRadius":"number","outerRotation":"number","outerSegments":"number","startAngle":"number"},
      "ellipsoid": {"axes":"array","center":"array","radius":"array","segments":"number"},
      "geodesicSphere": {"frequency":"number","radius":"number"},
      "roundedCuboid": {"center":"array","roundRadius":"number","segments":"number","size":"array"},
      "roundedCylinder": {"center":"array","height":"number","radius":"number","roundRadius":"number","segments":"number"},
      "extrudeFromSlices": {"numberOfSlices":"number"},
      "align": {"modes":"array","relativeTo":"array"},
      "vectorText": {"extrudeOffset":"number","height":"number","letterSpacing":"number","lineSpacing":"number","xOffset":"number","yOffset":"number"},
      "vectorChar": {"extrudeOffset":"number","height":"number","xOffset":"number","yOffset":"number"},
    },
    methodTypes: {
      "FluentGeom2": {
        "mirror": {"normal":"array","origin":"array"},
        "center": {"axes":"array","relativeTo":"array"},
        "align": {"modes":"array","relativeTo":"array"},
        "expand": {"delta":"number","segments":"number"},
        "offset": {"delta":"number","segments":"number"},
        "extrudeLinear": {"height":"number","twistAngle":"number","twistSteps":"number"},
        "extrudeRotate": {"angle":"number","segments":"number","startAngle":"number"},
        "extrudeHelical": {"angle":"number","endOffset":"number","height":"number","pitch":"number","segmentsPerRotation":"number","startAngle":"number"},
        "extrudeRectangular": {"delta":"number","height":"number","segments":"number","size":"number","twistAngle":"number","twistSteps":"number"},
        "extrudeFromSlices": {"numberOfSlices":"number"},
      },
      "FluentGeom3": {
        "mirror": {"normal":"array","origin":"array"},
        "center": {"axes":"array","relativeTo":"array"},
        "align": {"modes":"array","relativeTo":"array"},
        "expand": {"delta":"number","segments":"number"},
        "project": {"axis":"array","origin":"array"},
      },
      "FluentPath2": {
        "mirror": {"normal":"array","origin":"array"},
        "center": {"axes":"array","relativeTo":"array"},
        "align": {"modes":"array","relativeTo":"array"},
        "expand": {"delta":"number","segments":"number"},
        "extrudeRectangular": {"delta":"number","height":"number","segments":"number","size":"number","twistAngle":"number","twistSteps":"number"},
        "offset": {"delta":"number","segments":"number"},
        "appendArc": {"endpoint":"array","radius":"array","segments":"number","xaxisrotation":"number"},
        "appendBezier": {"controlPoints":"array","segments":"number"},
      },
      "FluentGeometryArray": {
        "mirror": {"normal":"array","origin":"array"},
        "center": {"axes":"array","relativeTo":"array"},
        "align": {"modes":"array","relativeTo":"array"},
      },
      "FluentGeom2Array": {
        "extrudeLinear": {"height":"number","twistAngle":"number","twistSteps":"number"},
        "extrudeRotate": {"angle":"number","segments":"number","startAngle":"number"},
        "extrudeHelical": {"angle":"number","endOffset":"number","height":"number","pitch":"number","segmentsPerRotation":"number","startAngle":"number"},
        "extrudeRectangular": {"delta":"number","height":"number","segments":"number","size":"number","twistAngle":"number","twistSteps":"number"},
      },
      "FluentPath2Array": {
        "expand": {"delta":"number","segments":"number"},
        "extrudeRectangular": {"delta":"number","height":"number","segments":"number","size":"number","twistAngle":"number","twistSteps":"number"},
      },
    },
    angles: [],
    methodAngles: {
      "FluentGeom2": ["rotate","rotateX","rotateY","rotateZ"],
      "FluentGeom3": ["rotate","rotateX","rotateY","rotateZ"],
      "FluentPath2": ["rotate","rotateX","rotateY","rotateZ"],
      "FluentGeometryArray": ["rotate","rotateX","rotateY","rotateZ"],
    },
  },
}
